import layoutHeaderAside from '@/layout/header-aside'

const meta = { requiresAuthA: true }

export default {
  path: '/',
  name: 'device',
  meta,
  redirect: { name: 'device-Manage' },
  component: layoutHeaderAside,
  props: true,
  children: [
    { path: 'deviceManage/deviceManage/:activeName', name: `device-Manage`, component: () => import('@/pages/deviceManage/deviceManage'), meta: { meta, title: '设备管理' } },
    { path: 'deviceManage/activeDevice', name: `device-Manage-activeDevice`, component: () => import('@/pages/deviceManage/activeDevice'), meta: { meta, title: '激活管理' } }
  ]
}
